import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-lg-6 col-12 chartRes ps-lg-0 mt-5" }
const _hoisted_2 = { class: "col-lg-6 col-12 chartRes pe-lg-0 mt-5" }
const _hoisted_3 = { class: "col-12 bg-white rounded-4 shadow p-0 m-0 mt-5" }
const _hoisted_4 = { class: "m-4" }
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_7 = { class: "m-4" }
const _hoisted_8 = { class: "col-lg-6 col-12 chartRes ps-lg-0 mt-5" }
const _hoisted_9 = { class: "col-lg-6 col-12 chartRes pe-lg-0 mt-5" }
const _hoisted_10 = { class: "col-12 bg-white rounded-4 shadow p-0 m-0 mt-5" }
const _hoisted_11 = { class: "m-4" }
const _hoisted_12 = { class: "fw-bold" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_14 = { class: "m-4" }
const _hoisted_15 = { class: "col-lg-6 col-12 chartRes ps-lg-0 mt-5" }
const _hoisted_16 = { class: "col-lg-6 col-12 chartRes pe-lg-0 mt-5" }
const _hoisted_17 = { class: "col-12 bg-white rounded-4 shadow p-0 m-0 mt-5" }
const _hoisted_18 = { class: "m-4" }
const _hoisted_19 = { class: "fw-bold" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_21 = { class: "m-4" }

import { translate } from '@/languages/i18n'
import PostGraphChartLineChildren from './PostGraphChartChildren'
import TablePostGraph from './TablePostGraph'

export default /*#__PURE__*/_defineComponent({
  props: {
  date: Object,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(PostGraphChartLineChildren), {
        date: __props.date,
        step: 40,
        title: _unref(translate)('CB10titlePV'),
        data_type: 1
      }, null, 8, ["date", "title"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(PostGraphChartLineChildren), {
        date: __props.date,
        step: 40,
        title: _unref(translate)('CB10titlePV2'),
        data_type: 2
      }, null, 8, ["date", "title"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h6", _hoisted_5, _toDisplayString(_unref(translate)('CB10titleArticlePostList')), 1)
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(TablePostGraph), {
          content_type: 1,
          date: __props.date
        }, null, 8, ["date"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_unref(PostGraphChartLineChildren), {
        date: __props.date,
        step: 40,
        title: _unref(translate)('CB10titlePV3'),
        data_type: 3
      }, null, 8, ["date", "title"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_unref(PostGraphChartLineChildren), {
        date: __props.date,
        step: 40,
        title: _unref(translate)('CB10titlePV4'),
        data_type: 4
      }, null, 8, ["date", "title"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("h6", _hoisted_12, _toDisplayString(_unref(translate)('CB10titleRecruitmentList')), 1)
      ]),
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_unref(TablePostGraph), {
          content_type: 2,
          date: __props.date
        }, null, 8, ["date"])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_unref(PostGraphChartLineChildren), {
        date: __props.date,
        step: 40,
        title: _unref(translate)('CB10titlePV5'),
        data_type: 5
      }, null, 8, ["date", "title"])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_unref(PostGraphChartLineChildren), {
        date: __props.date,
        step: 40,
        title: _unref(translate)('CB10titlePV6'),
        data_type: 6
      }, null, 8, ["date", "title"])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("h6", _hoisted_19, _toDisplayString(_unref(translate)('CB10JobListing')), 1)
      ]),
      _hoisted_20,
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_unref(TablePostGraph), {
          content_type: 3,
          date: __props.date
        }, null, 8, ["date"])
      ])
    ])
  ], 64))
}
}

})